import styled from "styled-components";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";

import AcmaIcon from "../../assets/images/icon_acma.webp"
import AhkIcon from "../../assets/images/icon_ahk.webp"
import ApacdIcon from "../../assets/images/icon_apacd.webp"
import AustChamIcon from "../../assets/images/icon_austcham.webp"
import FacebookIcon from "../../assets/images/icon_facebook.webp"
import InstagramIcon from "../../assets/images/icon_instagram.webp"
import IrpasIcon from "../../assets/images/icon_irpas.webp"
import LinkedInIcon from "../../assets/images/icon_linkedin.webp"
import MyNewsDeskIcon from "../../assets/images/icon_mynewsdesk.webp";
import SgTechIcon from "../../assets/images/icon_sgtech.webp"
import SidIcon from "../../assets/images/icon_sid.webp"
import TwitterIcon from "../../assets/images/icon_twitter.webp";
import YoutubeIcon from "../../assets/images/icon_youtube.webp";

const MemberOfIcon = styled.img`
  margin-right: 20px;
  margin-bottom: 10px;
`;

const Footer = (props) => {
  return (
    <Box
      sx={{
        width: "100%",
        marginTop: "64px",
        backgroundColor: "rgb(61, 61, 61)",
      }}
    >
      <Container
        maxWidth="lg"
        sx={{
          padding: "30px 0",
          color: "#ffffff",
          display: "flex",
          gap: "64px",
        }}
      >
        <Box sx={{ flex: 1 }}>
          <Box sx={{ marginBottom: "20px" }}>
            <Typography variant="h6">ABOUT US</Typography>
          </Box>
          <Typography variant="body1">
            Hong Bao Media provides a new generation of communication services to corporate clients throughout the Asia Pacific, for a new era of communications.
          </Typography>
        </Box>
        <Box sx={{ width: "240px" }}>
          <Box sx={{ marginBottom: "20px" }}>
            <Typography variant="h6">OUR OFFICES</Typography>
          </Box>
          <Box sx={{ marginBottom: "20px" }}>
            <Typography variant="body1">SINGAPORE</Typography>
            <Typography variant="body1">138 Robinson Road</Typography>
            <Typography variant="body1">#21-02 Oxley Tower Lobby 1</Typography>
            <Typography variant="body1">Singapore 068906</Typography>
          </Box>
          <Typography variant="body1">MALAYSIA</Typography>
          <Typography variant="body1">800 Jalan Sentul</Typography>
          <Typography variant="body1">D6 @ Sentul East</Typography>
          <Typography variant="body1">Unit 1-9</Typography>
          <Typography variant="body1">51000 Kuala Lumpur</Typography>
          <Typography variant="body1">Malaysia</Typography>
        </Box>
        <Box sx={{ flex: 1 }}>
          <Box sx={{ marginBottom: "20px" }}>
            <Typography variant="h6">FOLLOW US</Typography>
          </Box>
          <Box sx={{ display: "flex", gap: "24px" }}>
            <Link
              href="http://www.mynewsdesk.com/sg/hong-bao-media"
              target="_blank"
              rel="noopener"
            >
              <img src={MyNewsDeskIcon} alt="MyNewsDesk" />
            </Link>
            <Link
              href="https://www.linkedin.com/company/hongbaomedia"
              target="_blank"
              rel="noopener"
            >
              <img src={LinkedInIcon} alt="LinkedIn" />
            </Link>
            <Link
              href="https://twitter.com/HongBaoMedia"
              target="_blank"
              rel="noopener"
            >
              <img src={TwitterIcon} alt="Twitter" />
            </Link>
            <Link
              href="https://www.facebook.com/hongbaomedia/"
              target="_blank"
              rel="noopener"
            >
              <img src={FacebookIcon} alt="Facebook" />
            </Link>
            <Link
              href="https://www.youtube.com/user/hongbaomedia"
              target="_blank"
              rel="noopener"
            >
              <img src={YoutubeIcon} alt="Youtube" />
            </Link>
            <Link
              href="https://instagram.com/hongbaomedia"
              target="_blank"
              rel="noopener"
            >
              <img src={InstagramIcon} alt="Instagram" />
            </Link>
          </Box>
          <Box sx={{ marginTop: "30px", marginBottom: "20px" }}>
            <Typography variant="h6">MEMBER OF</Typography>
          </Box>
          <Box sx={{ display: "flex", flexWrap: "wrap", alignItems: "center" }}>
            <MemberOfIcon src={ApacdIcon} />
            <MemberOfIcon src={AhkIcon} />
            <MemberOfIcon src={AustChamIcon} />
            <MemberOfIcon src={SgTechIcon} />
            <MemberOfIcon src={SidIcon} />
            <MemberOfIcon src={IrpasIcon} />
            <MemberOfIcon src={AcmaIcon} />
          </Box>
        </Box>
      </Container>
    </Box>
  );
}

export default Footer;